import { Navigate, Outlet, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { LANDING_URL } from '../constants/AppUrlConstants';

const PrivilegedRoutes = ({ hasPrivilege }) => {
  const location = useLocation();
  const { state } = location;

  const stateToPersist = { ...state, redirectURL: location };

  return hasPrivilege ? (
    <div>
      <Outlet />
    </div>
  ) : (
    <Navigate to={LANDING_URL} state={{ ...stateToPersist }} replace />
  );
};

export default PrivilegedRoutes;

PrivilegedRoutes.propTypes = {
  hasPrivilege: PropTypes.bool.isRequired,
};
